import React, { useEffect } from "react";
import '../css/about.css'
import '../css/home.css'
import '../css/navbar.css'
import { Row, Col } from 'react-bootstrap';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailIcon from '@mui/icons-material/Mail';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { address, email, phnnumber } from "../data/personalData";
import { allProductList } from "../data/product";
import { useNavigate } from "react-router-dom";

export const Footer: React.FC = () => {
    const navigate = useNavigate();

    const gotoProduct = (id: string) => {
        navigate(`/product/product_detail/${id}`);
    }


    useEffect(() => {
        const footer = document.querySelector('footer');
        const handleScrollToTop = () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        };

        if (footer) {
            footer.addEventListener('click', handleScrollToTop);
        }


        return () => {
            if (footer) {
                footer.removeEventListener('click', handleScrollToTop);
            }
        };
    }, []);


    return (
        <>
            <footer className="bg-dark text-white fw-light">
                <br />
                <br />
                <Row className="pageContentSpacing m-auto pt-4">
                    <Col md={4} sm={12} xs={12}>
                        <h4>About Us</h4>
                        <p className="pragraph">
                            We provide expert industrial power solutions to businesses. With have over 10 years of experience in this field, so your business is evergreen to your expectations.</p>
                        <p className="pragraph"> We deal in new products, second hand products and provide services also. So feel free to contact us for any kind of query and suggestion.</p>
                    </Col>

                    <Col md={4} sm={12} xs={12} className="mb-3">
                        <h4>Our Latest Products</h4>
                        {allProductList.map((data, index) => {
                            return <li className="showlink" style={{ cursor: "pointer" }} key={index} onClick={() => gotoProduct(data.id)}> {data.name}   </li>
                        })}
                    </Col>
                    <Col md={4} sm={12} xs={12}>
                        <h4>Contact Us</h4>
                        <div className="d-flex">
                            <div><LocationOnIcon className="d-inline p-1 " /></div>
                            <div><p className="d-inline pragraph" >{address}</p></div>
                        </div>
                        <hr />
                        <a className=" contact fw-light text-white m-2" href="mailto:harielectricworks@yahoo.in"><MailIcon className="p-1" />{email}</a>
                        <p className="gray-text">We reply within 24 hour's</p>
                        <hr />
                        <h6 className="contact fw-light text-white m-2"><LocalPhoneIcon className="p-1" /> <a href={`tel:${phnnumber}`} className="phone-number-link contact text-white"><span className="px-1">+91</span>
                            {phnnumber}
                        </a>
                        </h6>
                        <p className="gray-text">Offering 24/7 availability</p>
                    </Col>
                </Row>
                <p className="pb-2 mb-0 text-center text-secondary" style={{ fontSize: '13px' }}> RnR Technologies &copy; 2024 - {new Date().getFullYear()}. All rights reserved.</p>
            </footer>
        </>
    )
};